const off = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M8.216%209.63L1.293%202.707l1.414-1.414%2020%2020-1.414%201.414-6.766-6.765L9%2022.85V15H3.92l4.296-5.37zm4.888%204.889l-3.466-3.466L8.081%2013H11v4.15l2.104-2.631zm-2.39-8.012L15%201.149V9h5.08l-3.054%203.819-1.423-1.423.316-.396h-.712L13%208.793V6.85l-.863%201.079-1.423-1.423z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
export {
  off as default
};
//# sourceMappingURL=off.svg.es.js.map
